import AppRouter from "./AppRouter";
import AppProviders from "./providers/AppProviders";

const App = (): JSX.Element => {
  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
};

export default App;
